import {
  CreateActivityInterface,
  UpdateActivityInterface,
} from 'pages/Activities/activities.context';
import { ValidationError } from 'components/ValidationErrors/ValidationErrors';
import validateQuestion from 'pages/Activities/ActivityAssignmentStep/StepQuestion/utils/validateQuestion';

export function activityValidator(
  activity: CreateActivityInterface | UpdateActivityInterface
): boolean {
  const stepErrors = activity.steps
    .map((step) => {
      const errors: ValidationError[] = [];
      if (step.question) {
        const questionErrors = validateQuestion(step.question);
        questionErrors.length && errors.push(...questionErrors);
      }

      return {
        step,
        errors,
      };
    })
    .filter((x) => !!x.errors.length);

  return !stepErrors.length;
}
